import React, { useContext, useState, useRef } from 'react';
import "react-phone-input-2/lib/style.css"; // Import styles for react-phone-input-2
import PhoneInput from "react-phone-input-2";
import { Link } from 'react-router-dom';
import { LanguageContext } from './context/LanguageContext';
import SignatureCanvas from 'react-signature-canvas'; // Import SignatureCanvas

const Step3 = ({ formData, handleChange, handlePrev, handleSubmit }) => {
    const [showDialog, setShowDialog] = useState(false);
    const sigCanvas = useRef(null); // Reference to the signature canvas

    const isFormValid = () => {
        const requiredFields = [
            "authorizedUserName",
            "authorizedUserTitle",
            "authorizedUserPhone",
            "authorizedUserEmail",
            "beneficialName",
            "beneficialDateOfBirth",
            "beneficialPercentage",
            "authorizationName",
            "authorizationTitle",
            "authorizationDate",
            "privacyPolicy",
            "agreeTerms",
            "signature" // Add signature as a required field
        ];

        return requiredFields.every((field) => {
            const value = formData[field];
            if (typeof value === "string") {
                return value.trim() !== "";
            }
            if (typeof value === "boolean") {
                return value === true;
            }
            return value != null;
        });
    };

    const submitBtn = () => {
        if (isFormValid()) {
            setShowDialog(true); // Show dialog box
        } else {
            alert("Please fill out all required fields correctly, including the signature.");
        }
    };

    const clearSignature = () => {
        sigCanvas.current.clear();
        handleChange({ target: { name: "signature", value: "" } });
    };

    const saveSignature = () => {
        const signatureData = sigCanvas.current.toDataURL("image/png");
        // console.log("Signature Data:", signatureData); // Debug here
        handleChange({ target: { name: "signature", value: signatureData } });
    };

    const { language } = useContext(LanguageContext);

    return (
        <div>
            <h1 className="text-center text-2xl font-semibold mb-8">{language === 'en' ? 'Authorized Users' : 'Usuarios autorizados'}</h1>
            <div className="flex gap-8">
                <div className='w-full'>
                    <h6 className='font-medium mb-1 flex items-center gap-1 text-heading'>{language === 'en' ? 'Name' : 'Nombre'} <span className='text-red-600'>*</span></h6>
                    <input
                        type="text"
                        name="authorizedUserName"
                        onChange={handleChange}
                        value={formData.authorizedUserName}
                        className='border border-gray-300 rounded-md p-2 w-full mb-4 outline-none focus:border-primary'
                        required
                    />
                </div>
                <div className='w-full'>
                    <h6 className='font-medium mb-1 flex items-center gap-1 text-heading'>{language === 'en' ? 'Title' : 'Título'} <span className='text-red-600'>*</span></h6>
                    <input
                        type="text"
                        name="authorizedUserTitle"
                        onChange={handleChange}
                        value={formData.authorizedUserTitle}
                        className='border border-gray-300 rounded-md p-2 w-full mb-4 outline-none focus:border-primary'
                        required
                    />
                </div>
                <div className='w-full'>
                    <h6 className='font-medium mb-1 flex items-center gap-1 text-heading'>{language === 'en' ? 'Phone Number ' : 'Número de teléfono'}<span className='text-red-600'>*</span></h6>
                    <PhoneInput
                        country={"us"}
                        value={formData.authorizedUserPhone}
                        onChange={(value) =>
                            handleChange({ target: { name: "authorizedUserPhone", value } })
                        }
                        inputClass="border border-gray-300 rounded-md p-2 w-2 mb-4 outline-none"
                        required
                    />
                </div>
                <div className='w-full'>
                    <h6 className='font-medium mb-1 flex items-center gap-1 text-heading'>{language === 'en' ? 'Email' : 'Correo electrónico'} <span className='text-red-600'>*</span></h6>
                    <input
                        type="text"
                        name="authorizedUserEmail"
                        onChange={handleChange}
                        value={formData.authorizedUserEmail}
                        className='border border-gray-300 rounded-md p-2 w-full mb-4 outline-none focus:border-primary'
                        required
                    />
                </div>
            </div>

            <h1 className="text-center text-2xl font-semibold mb-8 mt-7">{language === 'en' ? 'Beneficial Owner' : 'Propietario beneficiario'}</h1>
            <div className="flex gap-8">
                <div className='w-full'>
                    <h6 className='font-medium mb-1 flex items-center gap-1 text-heading'>{language === 'en' ? 'Name' : 'Nombre'} <span className='text-red-600'>*</span></h6>
                    <input
                        type="text"
                        name="beneficialName"
                        onChange={handleChange}
                        value={formData.beneficialName}
                        className='border border-gray-300 rounded-md p-2 w-full mb-4 outline-none focus:border-primary'
                        required
                    />
                </div>
                <div className='w-full'>
                    <h6 className='font-medium mb-1 flex items-center gap-1 text-heading'>{language === 'en' ? 'Date of Birth' : 'Fecha de nacimiento'} <span className='text-red-600'>*</span></h6>
                    <input
                        type="date"
                        name="beneficialDateOfBirth"
                        onChange={handleChange}
                        value={formData.beneficialDateOfBirth}
                        className='border border-gray-300 rounded-md p-2 w-full mb-4 outline-none focus:border-primary'
                        required
                    />
                </div>
                <div className='w-full'>
                    <h6 className='font-medium mb-1 flex items-center gap-1 text-heading'>{language === 'en' ? 'Ownership Percentage' : 'Porcentaje de propiedad'} <span className='text-red-600'>*</span></h6>
                    <input
                        type="number"
                        name="beneficialPercentage"
                        onChange={handleChange}
                        value={formData.beneficialPercentage}
                        className='border border-gray-300 rounded-md p-2 w-full mb-4 outline-none focus:border-primary'
                        required
                    />
                </div>
            </div>

            <h1 className="text-center text-2xl font-semibold mb-1 mt-7">{language === 'en' ? 'Authorization' : 'Autorización'}</h1>
            <p className='mb-4'>{language === 'en' ? 'All transactions under this Agreement are facilitated by Monex Inc. dba Monex USA ("Monex"), a licensed money transmitter. By signing below, the applicant authorizes Monex to open an account for currency exchange and payments and certifies that the provided information is accurate and complete.' : 'Todas las transacciones bajo este Acuerdo son facilitadas por Monex Inc. dba Monex USA ("Monex"), un transmisor de dinero autorizado. Al firmar a continuación, el solicitante autoriza a Monex a abrir una cuenta para cambio de moneda y pagos y certifica que la información proporcionada es precisa y completa.'}</p>
            <div className="flex gap-6">
                <div className='w-full'>
                    <h6 className='font-medium mb-1 flex items-center gap-1 text-heading'>{language === 'en' ? 'Name (Signature)' : 'Nombre (Firma)'} <span className='text-red-600'>*</span></h6>
                    <input
                        type="text"
                        name="authorizationName"
                        onChange={handleChange}
                        value={formData.authorizationName}
                        className='border border-gray-300 rounded-md p-2 w-full mb-4 outline-none focus:border-primary'
                        required
                    />
                </div>
                <div className='w-full'>
                    <h6 className='font-medium mb-1 flex items-center gap-1 text-heading'>{language === 'en' ? 'Title / Position' : 'Título/Posición'} <span className='text-red-600'>*</span></h6>
                    <input
                        type="text"
                        name="authorizationTitle"
                        onChange={handleChange}
                        value={formData.authorizationTitle}
                        className='border border-gray-300 rounded-md p-2 w-full mb-4 outline-none focus:border-primary'
                        required
                    />
                </div>
                <div className='w-full'>
                    <h6 className='font-medium mb-1 flex items-center gap-1 text-heading'>{language === 'en' ? 'Date' : 'Fecha'} <span className='text-red-600'>*</span></h6>
                    <input
                        type="date"
                        name="authorizationDate"
                        onChange={handleChange}
                        value={formData.authorizationDate}
                        className='border border-gray-300 rounded-md p-2 w-full mb-4 outline-none focus:border-primary'
                        required
                    />
                </div>
            </div>

            {/* Digital Signature Section */}
            <div className="mt-6">
                <h6 className='font-medium mb-1 flex items-center gap-1 text-heading'>{language === 'en' ? 'Digital Signature' : 'Firma Digital'} <span className='text-red-600'>*</span></h6>
                <SignatureCanvas
                    ref={sigCanvas}
                    penColor="black"
                    canvasProps={{ className: "border border-gray-300 rounded-md w-full h-32 mb-4" }}
                    onEnd={saveSignature} // Save signature when the user stops drawing
                />
                <button
                    className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400 mb-4"
                    onClick={clearSignature}
                >
                    {language === 'en' ? 'Clear Signature' : 'Borrar Firma'}
                </button>
            </div>

            <div>
                <h6 className='font-medium mb-1 flex items-center gap-1 text-heading'>{language === 'en' ? 'Please Read and Tick' : 'Por favor lea y marque'} <span className='text-red-600'>*</span></h6>
                <div className="flex gap-2">
                    <input
                        type="checkbox"
                        id="privacyPolicy"
                        name="privacyPolicy"
                        onChange={(e) => handleChange({ target: { name: 'privacyPolicy', value: e.target.checked } })}
                        checked={formData.privacyPolicy || false}
                        className="mr-2"
                    />
                    <label htmlFor="privacyPolicy" className="flex items-center">
                        I agree to the
                        <Link
                            to="https://www.monexusa.com/privacy-policy/"
                            target="_blank"
                            className="text-primary font-semibold ml-1"
                        >
                            Privacy Policy
                        </Link>
                    </label>
                </div>
                <div className="flex gap-2">
                    <input
                        type="checkbox"
                        id="agreeTerms"
                        name="agreeTerms"
                        onChange={(e) => handleChange({ target: { name: 'agreeTerms', value: e.target.checked } })}
                        checked={formData.agreeTerms || false}
                        className="mr-2"
                    />
                    <label htmlFor="agreeTerms" className="flex items-center">
                        I agree to the
                        <Link
                            to="https://www.monexusa.com/user-agreement/"
                            target="_blank"
                            className="text-primary font-semibold ml-1"
                        >
                            User Agreement
                        </Link>
                    </label>
                </div>
            </div>

            <div className='flex gap-5'>
                <button
                    className={`flex justify-center w-full py-2 mt-8 rounded-lg bg-secondary text-primary font-bold hover:bg-secondary/80`}
                    onClick={handlePrev}
                >
                    {language === 'en' ? 'Previous' : 'Previo'}
                </button>
                <button
                    className={`flex justify-center w-full py-2 mt-8 rounded-lg ${isFormValid() ? "bg-primary text-white hover:bg-primary/90" : "bg-gray-300 text-gray-500 cursor-not-allowed"}`}
                    onClick={submitBtn}
                    disabled={!isFormValid()}
                >
                    {language === 'en' ? 'Submit' : 'Entregar'}
                </button>
            </div>

            {showDialog && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
                    <div className="bg-white p-6 rounded shadow-lg w-1/3">
                        <h2 className="text-xl font-semibold mb-4">{language === 'en' ? 'Confirm Submission' : 'Confirmar envío'}</h2>
                        <p className="mb-6">{language === 'en' ? 'You have filled all the required information. Do you want to submit the form?' : 'Ha completado toda la información requerida. ¿Quieres enviar el formulario?'}</p>
                        <div className="flex justify-end gap-4">
                            <button
                                className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
                                onClick={() => setShowDialog(false)}
                            >
                                {language === 'en' ? 'Cancel' : 'Cancelar'}
                            </button>
                            <button
                                className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                                onClick={handleSubmit}
                            >
                                {language === 'en' ? 'Submit' : 'Entregar'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Step3;